import React from 'react';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import { connect } from 'react-redux';
import renderTextField from '../../components/MaterialUi/renderTextField';
import * as actions from '../../redux/projApollo/actions';
import { checkboxLabel,checkboxCustomStyle,checkboxCustomLabelStyle } from './CheckboxUtil';
import Paper from 'material-ui/Paper'
import ContainerRowSpace from '../../components/common/ContainerRowSpace'
import RFSelectWithOverrideComponent from '../../components/ReduxFormComps/RFSelectWithOverrideComponent'
import RFDatePickerField from '../../components/ReduxFormComps/RFDatePickerField'
import { validateAddNewItem } from './others/validation'

const styles = {
    textFieldStyle: {
        width: '310px'
    } 
}

const cancelButtonOnClick=(e,props)=>{
    e.preventDefault();
    props.cancelAddInvItemForm();
}

const AddInvoiceItemForm = props => {
    const { handleSubmit,pristine,submitting, isOverrideColLChargeDesc,isOverrideColPServiceAddress, initialValues,projApollo } = props;
    
    return (
        <div>
            <Paper>
                <div className='container'>
                    <ContainerRowSpace />
                    <form onSubmit={handleSubmit} >
                    <div className="row">
                        <div className="col-sm-5">
                            <h5>Add/Edit Invoice Items</h5>
                        </div> 
                        <div className="col-sm-3">
                            <button className="btn btn-outline-primary" type="submit" disabled={pristine || submitting}>
                            Save
                            </button>
                            &nbsp;&nbsp;&nbsp;
                            <button className="btn btn-outline-secondary" type="button" onClick={(e)=>cancelButtonOnClick(e,props)}>
                                Cancel
                            </button>
                        </div>
                    </div>
                    <ContainerRowSpace />
                    <div className="row">
                        <div className="col-sm">
                            <Field
                                name="colHHdrAcctNo"
                                component={renderTextField}
                                label="Column H Header Account Number"
                                style={styles.textFieldStyle}
                            />
                        </div>
                        <div className="col-sm">
                            <Field
                                name="colIHdrTotal"
                                component={renderTextField}
                                label="Column I Header Total"
                                type="number"
                                style={styles.textFieldStyle}
                            />
                        </div>
                    </div>
                    <ContainerRowSpace />
                    <div className="row">
                        <div className="col-sm">
                            <Field
                                name="colJHdrConsump"
                                component={renderTextField}
                                label="Column J Header Consumption"
                                style={styles.textFieldStyle}
                            />
                        </div>
                        <div className="col-sm">
                            <Field
                                name="colKHdrConsumpUnits"
                                component={renderTextField}
                                label="Column K Header Consumption Units"
                                style={styles.textFieldStyle}
                            />
                        </div>
                    </div>
                    <ContainerRowSpace />
                    <div className="row">
                        <div className="col-sm">
                            <RFSelectWithOverrideComponent 
                                label="Column L Charge Description"
                                fieldName="colLChargeDesc"
                                datas={projApollo.invItemChargeDescs}
                                dataDict={{code: 'code', desc: 'desc'}}
                                customStyle={styles.textFieldStyle}
                                overrideCheckBoxFieldName='isOverrideColLChargeDesc'
                                overrideCheckBoxLabel={checkboxLabel(isOverrideColLChargeDesc,'Column L')}
                                isOverrideColLChargeDesc={props.isOverrideColLChargeDesc}
                            />
                        </div>
                        <div className="col-sm">
                            <Field
                                name="colMCharge"
                                component={renderTextField}
                                label="Column M Charge"
                                type="number"
                                style={styles.textFieldStyle}
                            />
                        </div>
                    </div>
                    <ContainerRowSpace />
                    <div className="row">
                        <div className="col-sm">
                            <Field
                                name="colNConsump"
                                component={renderTextField}
                                label="Column N Consumption"
                                style={styles.textFieldStyle}
                            />
                        </div>
                        <div className="col-sm">
                            <Field
                                    name="colOConsumpUnit"
                                    component={renderTextField}
                                    label="Column O Consumption Units"
                                    style={styles.textFieldStyle}
                                />
                        </div>
                    </div>
                    <ContainerRowSpace />
                    <div className="row">
                        <div className="col-sm">
                            <RFSelectWithOverrideComponent 
                                label="Column P Service Address"
                                fieldName="colPServiceAddress"
                                datas={projApollo.invItemServiceAddrs}
                                dataDict={{code: 'code', desc: 'desc'}}
                                customStyle={styles.textFieldStyle}
                                overrideCheckBoxFieldName='isOverrideColPServiceAddress'
                                overrideCheckBoxLabel={checkboxLabel(isOverrideColPServiceAddress,'Column P')}
                                isOverrideColPServiceAddress={props.isOverrideColPServiceAddress}
                            />    
                        </div>
                        <div className="col-sm">
                            <Field
                                name="colQBillingStartDate"
                                component={RFDatePickerField}
                                label="Column Q Billing Start Date"
                                inputDateFormat='MM/DD/YYYY'
                                style={styles.textFieldStyle}
                                inputNote="US date format MM/DD/YYYY"
                            />
                        </div>
                    </div>
                    <ContainerRowSpace />
                    <div className="row">
                        <div className="col-sm">
                            <Field
                                name="colRBillingEndDate"
                                component={RFDatePickerField}
                                label="Column R Billing End Date"
                                inputDateFormat='MM/DD/YYYY'
                                style={styles.textFieldStyle}
                                inputNote="US date format MM/DD/YYYY"
                            />
                        </div>
                        <div className="col-sm">
                            <Field
                                name="colSPartialFinal"
                                component={renderTextField}
                                label="Column S Partial/Final"
                                style={styles.textFieldStyle}
                            />
                        </div>
                    </div>
                    <ContainerRowSpace />
                    <div className="row">
                        <div className="col-sm">
                            <Field
                                    name="colTDaysOfService"
                                    component={renderTextField}
                                    label="Column T Days of Service"
                                    style={styles.textFieldStyle}
                                />
                        </div>
                    </div> 
                    <ContainerRowSpace />
                    </form>
                </div>
            </Paper>
        </div>    
    )
}

const submit = (values, dispatch, props) => {
    const { jwt,taskAcceptedInfoId,projApollo } = props;
    let newInvItem=values;
    const { apolloItem } = projApollo;
    
    if (apolloItem && apolloItem.id){
        props.updateApolloItem(jwt,values,apolloItem.id);
    }else{
        props.createNewApolloItem(jwt,newInvItem,taskAcceptedInfoId);
    }
}
    

const AddInvItemReduxForm = reduxForm({
    form: 'addInvItemForm',
    enableReinitialize: true,
    validate: validateAddNewItem,
    onSubmit: submit,
})(AddInvoiceItemForm)

const selector = formValueSelector('addInvItemForm')

const mapStateToProps = (state, ownProps) => {
    return {
        projApollo: state.projApollo,
        isOverrideColLChargeDesc: selector(state, 'isOverrideColLChargeDesc'),
        isOverrideColPServiceAddress: selector(state, 'isOverrideColPServiceAddress'),
        initialValues: state.projApollo.apolloItem
    }
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
      createNewApolloItem: (jwt,newApolloItem,taskAcceptedInfoId) => {
         dispatch(actions.createNewApolloItem(jwt,newApolloItem,taskAcceptedInfoId))  
      },
      updateApolloItem: (jwt,updateApolloItem,id) => {
        dispatch(actions.updateApolloItem(jwt,updateApolloItem,id))  
      },
      cancelAddInvItemForm: () => {
         dispatch(actions.cancelAddInvItemForm())  
      },
    }
}

export default connect(mapStateToProps,mapDispatchToProps)(AddInvItemReduxForm);


// WEBPACK FOOTER //
// ./src/views/ProjectApollo/AddInvoiceItemForm.js